import React, { Component } from 'react';
import windowSize from 'react-window-size';

import './Track.css';
import { PIXEL_PER_UNIT, TRACK_LENGTH, MAX_SPEED } from '../../consts';

class TrackCore extends Component {
  render() {
    let {
      windowWidth: width,
      windowHeight: height,
      car1,
      car2,
      car1Speed,
      car2Speed,
      car1Gasoline,
      car2Gasoline,
    } = this.props;
    
    return (
      <div className="track">
        <div className="road" style={{
          height: TRACK_LENGTH * PIXEL_PER_UNIT + height,
          transform: `translateY(${car1 * PIXEL_PER_UNIT}px)`
        }}>
          <div className="start" style={{
            bottom: height/2,
          }}/>
          <div className="finish" style={{
            bottom: TRACK_LENGTH * PIXEL_PER_UNIT + height/2,
          }}/>
        </div>
        <div className={`car car-1 ${ car1 < TRACK_LENGTH && car1Gasoline && car1Speed > MAX_SPEED * 0.7 ? 'nitro' : '' }`}/>
        <div className={`car car-2 ${ car2 < TRACK_LENGTH && car2Gasoline && car2Speed > MAX_SPEED * 0.7 ? 'nitro' : '' }`} style={{
          transform: `translateY(${(car1 - car2) * PIXEL_PER_UNIT}px)`
        }}/>
      </div>
    );
  }
}

export const Track = windowSize(TrackCore);


// WEBPACK FOOTER //
// ./src/components/Track/Track.js